<template>
  <modal name="edit-category-modal" @before-open="beforeOpen" transition="pop-out" :width="400" :height="350">
    <h4 class="text-center panel-heading">Categorie bewerken</h4>
    <form @submit.prevent="editCategory()">
      <div class="col-sm-12 mb-20">
        <label>Nederlandse vertaling*</label>
        <input type="text"
               name="dutch_translation"
               class="form-control"
               required
               placeholder="..."
               v-model="category.dutchTranslation">
      </div>
      <div class="col-sm-12 mb-20">
        <label>Franse vertaling</label>
        <input type="text"
               name="french_translation"
               class="form-control"
               placeholder="..."
               v-model="category.frenchTranslation">
      </div>
      <div class="col-sm-12 mb-20">
        <label>Afbeelding (150 x 150)</label>
        <input type="file"
               @change="upload($event.target.files)" accept="image/*">
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-4">
            <button type="submit" class="btn btn-danger">Opslaan</button>
          </div>
        </div>
      </div>
    </form>
  </modal>
</template>
<script>
  import {mapGetters} from 'vuex'
  import * as types from '../../store/mutation-types'

  export default {
    name: 'EditCategory',
    data () {
      return {
        modalHeight: 300,
        category: {
          parentId: null,
          dutchTranslation: '',
          frenchTranslation: '',
          imageLocation: ''
        },
        file: null
      }
    },
    methods: {
      editCategory () {
        this.$store.commit(types.SET_CATEGORY_TO_UPDATE, this.category)
        this.$store.dispatch('updateCategory').then(() => {
          if (this.isCategoryUpdated) {
            this.category.parentId = null
            this.category.dutchTranslation = ''
            this.category.frenchTranslation = ''
            this.category.imageLocation = ''
            this.$modal.hide('edit-category-modal')
            this.$notify({group: 'success', type: 'success', title: 'Succes', text: 'Categorie bewerkt!'})
          } else {
            this.$notify({group: 'danger', type: 'error', title: 'Error', text: 'Kan deze categorie niet bewerken, probeer het later opnieuw!'})
          }
        })
      },
      beforeOpen (event) {
        if (event.params.category) {
          this.category = event.params.category
        }
      },
      upload (image) {
        let data = new FormData()
        if (image !== '') {
          this.file = image.item(0)
          data.append('images', this.file, this.file.name)

          this.$store.dispatch('uploadImage', data).then(() => {
            if (this.imageLocation) {
              this.category.imageLocation = this.imageLocation
            }
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        isCategoryUpdated: 'isCategoryUpdated',
        imageLocation: 'imageLocation'
      })
    }
  }
</script>

<style scoped>
  .mb-20 {
    margin-bottom: 20px;
  }
</style>
